module.exports = __webpack_public_path__ + "media/application/images/icons/dropdown-arrow-4630bc67e119a47df00ff317169af392.svg";